//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/SelectISurface.js";
import "../Features/Features.FaceRecognitionBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"BlendCollector",0,"ScCollector",0],[1,"CapFace",0,"SelectISurface",0],[0,"CapOption",1,0],[0,"CapPlane",1,"Plane",0],[0,"DeletePartialBlend",1,0],[1,"FaceCollector",0,"ScCollector",0],[0,"FaceEdgeBlendPreference",1,0],[1,"FaceRecognized",0,"Features.FaceRecognitionBuilder",0],[0,"Heal",1,0],[0,"HealPlanar",1,0],[1,"MaxBlendRadius",0,"Expression",0],[1,"MaxHoleDiameter",0,"Expression",0],[0,"Setback",1,0],[0,"SpecifyBlend",1,0],[0,"Type",1,0],[0,"UseHoleDiameter",1,0]],[[[],"DeleteFaceOnMultibodies",{},0,0]],[]];
SPLM.Features.DeleteFaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DeleteFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DeleteFaceBuilder.SelectTypes = Object.freeze({
    "Face" : "Face", "Hole" : "Hole", "Blend" : "Blend", "FaceEdgeBlend" : "FaceEdgeBlend"});

SPLM.Features.DeleteFaceBuilder.CapOptionValues = Object.freeze({
    "FaceOrPlane" : "FaceOrPlane", "NewPlane" : "NewPlane"});

SPLM.Features.DeleteFaceBuilder.SetbackOptions = Object.freeze({
    "SelectedBlend" : "SelectedBlend", "NeighborBlend" : "NeighborBlend"});

SPLM.Features.DeleteFaceBuilder.FaceEdgeBlendPreferenceOptions = Object.freeze({
    "Notch" : "Notch", "Cliff" : "Cliff"});

export default SPLM;